import "./astro-medallion.3cc4458c.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $aRPiL = parcelRequire("aRPiL");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

const $93c05bd4543c9b04$export$b94310965bed44e6 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: "Hello Home"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "/astro-medallion/",
                children: "Astro Medallion"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "/tutor/",
                children: "Tutor"
            })
        ]
    });
};


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $aRPiL.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.StrictMode), {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("meta", {
            property: "og:image",
            content: "./astro-medallion/PXL_20251121_165222077.PORTRAIT.jpg"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93c05bd4543c9b04$export$b94310965bed44e6), {})
    ]
}));


//# sourceMappingURL=copper-rose-workshop.1743a51a.js.map
